import { AuthGuard } from "../../../auth/helpers";
import { RequestsListComponent } from "./pages/list/requests-list.component";
import { CreateRequestComponent } from "./pages/create/create-request.component";
import { RequestDetailComponent } from "./pages/detail/request-detail.component";
import { EditRequestComponent } from "./pages/edit/edit-request.component";
import { IRoute } from "app/auth/models/utils-interfaces";

const requestsRoutes: IRoute[] = [
  {
    path: "dashboard/requests-list",
    component: RequestsListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/create-request",
    component: CreateRequestComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/detail-request/:id",
    component: RequestDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/edit-request/:id",
    component: EditRequestComponent,
    canActivate: [AuthGuard],
  },
];
export default requestsRoutes;
